import { BRAND } from "../config/brand";

/* ================================================================
   클론(복제) 랜딩 사이트 전용 CTA 처리.
   - 클론은 PG(결제)가 없으므로 구매/장바구니/바로구매/렌탈문의/상담 등
     "전환" 액션을 전부 일광오피스 카카오톡 채널로 보낸다.
   - 원본 ikoffices.com은 window.__SITE_BRAND__ 를 주입하지 않아 kakaoUrl 이
     비어있음 → CLONE_MODE=false → 기존 PG/장바구니 동작 그대로.
   ================================================================ */
export const CLONE_MODE = !!BRAND.kakaoUrl;

export function openKakaoInquiry() {
  if (BRAND.kakaoUrl) {
    window.open(BRAND.kakaoUrl, "_blank", "noopener,noreferrer");
  }
}

/* 이벤트 핸들러 상단에서 호출: 클론이면 기본동작 막고 카카오 오픈 후 true 반환.
   사용: const onBuy = (e) => { if (ctaToKakao(e)) return; ...원래 로직... } */
export function ctaToKakao(e) {
  if (!CLONE_MODE) return false;
  if (e && typeof e.preventDefault === "function") e.preventDefault();
  openKakaoInquiry();
  return true;
}
